import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import safeGet from 'just-safe-get'
import unique from 'just-unique'
import { v4 as uuidv4 } from 'uuid'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: {
      isPrivileged: false,
      token: null,
      user: {
        email: null,
        displayName: null,
        images: null,
        id: null,
        firstname: null,
        lastname: null,
        lastLogin: null,
        isAdmin: false,
        loggedIn: false
      }
    },
    playlists: [],
    playlistOwners: [],
    friendsSelection: [],
    songs: [],
    shuffledPlaylist: [],
    latestCreatedPlaylist: null
  },
  getters: {
    getCurrentUser: state => { return state.auth.user },
    getUserToken: state => { return state.auth.token },
    getPlaylists: state => {
      return state.playlists
    },
    getPlaylistOwners: state => { return state.playlistOwners },
    getFriendsSelection: state => { return state.friendsSelection },
    getSongs: state => {
      const randomElements = []
      for (var i = 0; i < 50; i++) {
        randomElements.push(state.songs[Math.floor(Math.random() * state.songs.length)])
      }
      return unique(randomElements)
    },
    getNewPlaylist: state => {
      return unique(state.shuffledPlaylist)
    },
    getLatestCreated: state => {
      return state.latestCreatedPlaylist
    }
  },
  mutations: {
    resetPlaylist (state) {
      state.shuffledPlaylist = []
    },
    reShufflePlaylist (state) {
      const randomElements = []
      for (var i = 0; i < 50; i++) {
        randomElements.push(state.songs[Math.floor(Math.random() * state.songs.length)])
      }
      state.shuffledPlaylist = unique(randomElements)
    },
    setUser (state, user) {
      state.auth.user.email = user.email
      state.auth.user.displayName = user.display_name
      state.auth.user.images = user.images
      state.auth.user.id = user.id
      state.auth.user.loggedIn = true
    },
    setAuthToken (state, token) {
      state.auth.token = `Bearer ${token}`
    },
    setPlaylists (state, playlists) {
      state.playlists = playlists
    },
    setPlaylistOwners (state, playlistOwners) {
      state.playlistOwners = playlistOwners
    },
    addPlaylistOwner (state, playlistOwner) {
      if (state.playlistOwners.find(element => element.id === playlistOwner.id)) {
        console.log('duplicate not added')
      } else {
        const userId = playlistOwner.id
        const profileUrl = `https://api.spotify.com/v1/users/${userId}`
        const playlistsUrl = `https://api.spotify.com/v1/users/${userId}/playlists`
        const owner = {
          ...playlistOwner,
          imageUrl: null
        }
        axios.get(profileUrl, { headers: { Authorization: state.auth.token } }).then(res => {
          const index = state.playlistOwners.findIndex(element => element.id === playlistOwner.id)
          const value = safeGet(res, 'data.images')
          if (typeof value[0] === 'undefined') {
            state.playlistOwners[index].imageUrl = null
          } else {
            state.playlistOwners[index].imageUrl = res.data.images[0].url
          }
        })
        axios.get(playlistsUrl, { headers: { Authorization: state.auth.token } }).then(res => {
          res.data.items.forEach(playlist => {
            playlist = {
              ...playlist,
              uuid: uuidv4()
            }
            state.playlists.push(playlist)
          })
        })
        state.playlistOwners.push(owner)
      }
    },
    addFriend (state, selectedFriend) {
      if (state.friendsSelection.find(friend => friend.id === selectedFriend.id)) {
        state.friendsSelection = state.friendsSelection.filter(function (friend) { return friend.id !== selectedFriend.id })
      } else {
        state.friendsSelection.push(selectedFriend)
      }
    },
    resetFriends (state) {
      state.friendsSelection = []
      state.songs = []
    },
    setLatestCreatedPlaylist (state, playlist) {
      state.latestCreatedPlaylist = playlist
    }
  },
  actions: {
    fetchFollows (context) {
      const url = `https://api.spotify.com/v1/users/${context.state.auth.user.id}/playlists?limit=50`
      const auth = context.state.auth.token
      axios.get(url, { headers: { Authorization: auth } }).then(res => {
        context.state.playlistOwners = []
        res.data.items.forEach(item => {
          context.commit('addPlaylistOwner', item.owner)
        })
      })
    },
    async getRandomPlaylistForFriendsSelection (context) {
      async function getAllSongs (url, auth) {
        await axios.get(url, { headers: { Authorization: auth } }).then(async res => {
          res.data.items.forEach(song => {
            song = {
              ...song,
              uuid: uuidv4()
            }
            context.state.songs.push(song)
          })
        })
      }
      const playlists = []
      const auth = context.state.auth.token
      context.state.friendsSelection.forEach(friend => {
        const friendsPlaylists = context.state.playlists.filter(function (playlist) { return playlist.owner.id === friend.id })
        friendsPlaylists.forEach(playlist => playlists.push(playlist))
      })
      playlists.forEach(async playlist => {
        await getAllSongs(playlist.tracks.href, auth)
      })
    }
  },
  modules: {
  }
})
